import { Injectable } from '@angular/core';
import { style as stepper_style } from '@primeuix/styles/stepper';
import { BaseStyle } from 'primeng/base';

const style = /*css*/ `
${stepper_style}

.p-steppanel .p-motion {
    display: grid;
    grid-template-rows: 1fr;
}
`;

const classes = {
    root: ({ instance }) => [
        'p-stepper p-component',
        {
            'p-readonly': instance.linear()
        }
    ],
    separator: 'p-stepper-separator'
};

@Injectable()
export class StepperStyle extends BaseStyle {
    name = 'stepper';

    style = style;

    classes = classes;
}

/**
 *
 * Stepper is a component that streamlines a wizard-like workflow, organizing content into coherent steps and visually guiding users through a numbered progression in a multi-step process.
 *
 * [Live Demo](https://www.primeng.org/stepper/)
 *
 * @module stepperstyle
 *
 */
export enum StepperClasses {
    /**
     * Class name of the root element
     */
    root = 'p-stepper',
    /**
     * Class name of the separator element
     */
    separator = 'p-stepper-separator'
}

export interface StepperStyle extends BaseStyle {}
